import type { SupplierPaymentInformationGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierPaymentInformation = <
  TData = SupplierPaymentInformationGetResponseType,
>(
  supplierId: number,
  supplierPaymentInformationId?: number | null,
  options?: ApiV2QueryOptions<TData>,
) => {
  const currentBusinessContext = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      currentBusinessContext?.business?.id,
      ServerStateKeys.SuppliersPaymentInformation,
      supplierPaymentInformationId,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business: currentBusinessContext?.business ?? null,
        method: "get",
        path: `suppliers/${supplierId}/supplier-payment-information/${supplierPaymentInformationId}`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: {
        scope: "business",
        user,
        business: currentBusinessContext?.business ?? null,
      },
      options: options,
    }),
  });
};
